import { render, staticRenderFns } from "./OverviewSelectCard.vue?vue&type=template&id=493239a6&scoped=true"
import script from "./OverviewSelectCard.vue?vue&type=script&lang=js"
export * from "./OverviewSelectCard.vue?vue&type=script&lang=js"
import style0 from "./OverviewSelectCard.vue?vue&type=style&index=0&id=493239a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493239a6",
  null
  
)

export default component.exports